import React, { createContext, useContext, useState, ReactNode } from 'react';

interface StorageContextType {
  currentStorageName: string;
  setCurrentStorageName: (name: string) => void;
}

const StorageContext = createContext<StorageContextType | undefined>(undefined);

export function StorageProvider({ children }: { children: ReactNode }) {
  const [currentStorageName, setCurrentStorageName] = useState("");

  return (
    <StorageContext.Provider value={{ currentStorageName, setCurrentStorageName }}>
      {children}
    </StorageContext.Provider>
  );
}

export function useStorage() {
  const context = useContext(StorageContext);
  if (context === undefined) {
    throw new Error('useStorage must be used within a StorageProvider');
  }
  return context;
}
